import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <main>
    <section className="ai-pagehead">
      <div className="ai-wrap">
        <h1>This page isn't here.</h1>
        <p>The link may be old or mistyped. The home page has everything we publish.</p>
        <div className="ai-actions">
          <Link className="ai-btn" to="/">Go to the home page</Link>
        </div>
      </div>
    </section>
  </main>
);

export default NotFound;
